import { twMerge } from 'tailwind-merge';
import React from 'react';
import useAppContext from 'flow/hooks/useAppContext';
import Icon from '../ui-components/Icon';

type Props = {
    file: File | null;
    validFileFormat: (file: File | null) => boolean;
    dropZoneRef: React.RefObject<HTMLLabelElement>;
    fileUploadRef: React.RefObject<HTMLInputElement>;
    validSoundTypes: string[];
    onFileChange: (file: File | null) => void;
    className?: string;
};

const FileUploadDropZone: React.FC<Props> = ({
    file,
    validFileFormat,
    dropZoneRef,
    fileUploadRef,
    validSoundTypes,
    onFileChange,
    className = '',
}) => {
    const { i18next } = useAppContext();

    const handleSoundFile = (e: React.ChangeEvent<HTMLInputElement>) => {
        const selectedFile = e.target.files?.[0];
        if (selectedFile && validSoundTypes.includes(selectedFile.type)) {
            onFileChange(selectedFile);
        } else {
            console.error('Invalid file type selected');
        }
    };
    return (
        <>
            <label
                htmlFor="fileUpload"
                className={twMerge(
                    'hover:border-main hover:text-main group flex h-36 cursor-pointer flex-col items-center justify-center rounded border border-dashed border-gray-400 bg-white',
                    file && validFileFormat(file) ? 'active' : '',
                    file && !validFileFormat(file) ? 'invalid' : '',
                    className,
                )}
                ref={dropZoneRef}
            >
                <Icon
                    className="group-hover:text-main text-gray-500"
                    iconKey="DropZoneIcon"
                />
                {file ? (
                    <div>{file.name}</div>
                ) : (
                    <div className="group-hover:text-main text-gray-500">
                        {i18next.t('Recorder.File.Button.Title')}
                    </div>
                )}
            </label>
            <input
                id="fileUpload"
                ref={fileUploadRef}
                type="file"
                style={{ display: 'none' }}
                accept={validSoundTypes.join(', ')}
                onChange={handleSoundFile}
            />
        </>
    );
};

export default FileUploadDropZone;
